import { createModel } from '@rematch/core';
import type { RootModel } from './models';

type PortalList = {
  [id: string]: HTMLElement;
};

/**
 * Portals model, manages the state of named dom elements which
 * are captured in the link function of the angular `react-portal` directive
 * and then used as portal destinations for react components in <Portal> component
 *
 * This lives in redux because if it did not, we would need to manually re-implement
 * event handling to trigger re-renders of the appropriate portal components. Given
 * that that kind of event handling is what redux is made for; this is best
 * implemented as a redux model.
 *
 * See ui/Portal for more description and details!
 */
export default createModel<RootModel>()({
  name: 'portals',
  state: {} as PortalList,
  reducers: {
    addPortal(
      state: PortalList,
      { portal, element }: { portal: string, element: HTMLElement },
    ) {
      return {
        ...state,
        [portal]: element,
      };
    },

    removePortal(
      state: PortalList,
      { portal }: { portal: string },
    ) {
      const {
        [portal]: omit,
        ...portals
      } = state;

      return portals;
    },
  },
});
